(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nz-pdp-rewards"] && !Shopify.designMode) return;
  try {
    (function () {
    var banners = document.querySelectorAll('[data-reward-banner]');
    if (!banners.length) return;

    banners.forEach(function (banner) {
      // Manual metafield override: points never change with variant, nothing to sync.
      if (banner.dataset.rewardMode !== 'auto') return;

      var pdp = banner.closest('.nz-pdp');
      var priceEl = pdp ? pdp.querySelector('[data-price]') : null;
      var pointsEl = banner.querySelector('[data-reward-points]');
      if (!priceEl || !pointsEl) return;

      var pct = parseFloat(banner.dataset.rewardPct);
      if (!pct || pct <= 0) return;

      var recalc = function () {
        var raw = priceEl.textContent || '';
        var cleaned = raw.replace(/[^0-9.,]/g, '').replace(/,/g, '');
        var num = parseFloat(cleaned);
        if (!isNaN(num)) {
          pointsEl.textContent = Math.max(0, Math.round((num * pct) / 100));
        }
      };

      // The existing NzProductForm swaps [data-price] textContent on variant change.
      // We only observe it — never touch that class — so this stays fully decoupled.
      var observer = new MutationObserver(recalc);
      observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
